import type { CardSettings } from '@backstage/plugin-home-react';

export type UserLink = {
  title: string;
  url: string;
};

export const USER_LINK_ITEM_SCHEMA = {
  type: 'object' as const,
  required: ['title', 'url'],
  properties: {
    title: { type: 'string' as const, title: 'Title' },
    url: { type: 'string' as const, title: 'URL', format: 'uri' as const },
  },
};

export const userLinksCardSettings: CardSettings = {
  schema: {
    title: 'Links',
    type: 'object',
    properties: {
      links: {
        type: 'array',
        title: 'Links',
        description: 'Shortcuts only you can see',
        items: USER_LINK_ITEM_SCHEMA,
      },
    },
  },
};

export function isValidHttpUrl(value: string): boolean {
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
}

export function parseUserLinks(value: unknown): UserLink[] {
  if (!Array.isArray(value)) {
    return [];
  }
  return value.filter((item): item is UserLink => {
    if (typeof item !== 'object' || item === null) {
      return false;
    }
    const link = item as Partial<UserLink>;
    return (
      typeof link.title === 'string' &&
      link.title.trim().length > 0 &&
      typeof link.url === 'string' &&
      isValidHttpUrl(link.url)
    );
  });
}
